import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { PublisherAttachmentSettingsAction } from '../../../domains/publisherAttachmentSettings/actions.types';

import type { NetworkPublisherSettings } from './types';

export type NetworkPublisherSettingsAction = PublisherAttachmentSettingsAction;

const initialState: NetworkPublisherSettings = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<NetworkPublisherSettings, NetworkPublisherSettingsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'PUBLISHER.LOAD_PUBLISHER_ATTACHMENT_SETTINGS_PENDING':
      return setPending();
    case 'PUBLISHER.LOAD_PUBLISHER_ATTACHMENT_SETTINGS_FULFILLED':
      return setFulfilled(action.payload);
    case 'PUBLISHER.LOAD_PUBLISHER_ATTACHMENT_SETTINGS_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
